<template>
	<transition-group name="list" :class="{
		'window-stack-view': true,
		active: windows.length > 0
	}">
		<component :class="{
			window: true,
			active: i == windows.length - 1
		}" v-for="(win, i) in windows" :key="i" :is="win.component" v-bind="win" @pop="$emit('pop')" />
	</transition-group>
</template>

<script>
	export default {
		props: {
			windows: {
				type: Array,
				required: true
			}
		}
	}
</script>

<style lang="scss" scoped>
	.window-stack-view {
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 10000;
		background-color: #00000000;
		pointer-events: none;

		/*display: grid;
		grid-template-columns: 	1fr;
		grid-template-rows: 	1fr;
		justify-items: center;
		align-items: center;*/

		transition: 100ms background-color ease-in-out;

		&.active {
			background-color: #000000be;
			pointer-events: all;
		}

		& > .window {
			opacity: 0;
			transition: 150ms opacity ease-in-out, 150ms transform ease-in-out;
			position: absolute;
			transform: scale(0.5); 

			&.active {
				opacity: 1;
				transform: scale(1); 
			}
		}
	}

	.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
		transform: scale(1.6) ! important; 
		opacity: 0 ! important;
	}
</style>